import { Button, Flex } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { CycleSelectDashboard } from "../Selectors/CyclesSelector";

const Filter = ({
  filters,
  setFilters,
  handleSetAssessmentPlan,
  assessmentPlanList,
  cycles,
  loadedCycles,
}) => {
  const { t } = useTranslation();
  const handleCycleSelect = (selectedCycleId) => {
    const selectedCycle = cycles.find((cycle) => cycle.id === selectedCycleId);
    setFilters({ ...filters, cycle: selectedCycle });
  };

  return (
    <Flex wrap="wrap" alignItems="end" gap="small" margin="0 0 small 0">
      <Flex.Item size="300px" padding="0 0 0 small">
        <CycleSelectDashboard
          selectHandler={handleCycleSelect}
          cycles={cycles}
          selectedCycle={filters.cycle}
          loadedCycles={loadedCycles}
        />
      </Flex.Item>
      <Flex.Item>
        <Button
          size="small"
          id="search-outcomes-button"
          color="primary"
          onClick={() =>
            handleSetAssessmentPlan(assessmentPlanList, filters.cycle)
          }
        >
          {t("search")}
        </Button>
      </Flex.Item>
    </Flex>
  );
};

export default Filter;
